import React, { useContext, useEffect, useState } from 'react';
import { DefaultContext } from '../../../context/context_default';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

// Importar ícones das fortunas
import imgIgn from '../../../assets/imagens/ign.png';
import imgVerbus from '../../../assets/imagens/verbus.png';
import imgKarma from '../../../assets/imagens/karma.png';
import imgDnama from '../../../assets/imagens/dnama.png';
import imgGnos from '../../../assets/imagens/gnos.png';
import imgOmna from '../../../assets/imagens/omna.png';

const FortuneChart = ({ arvore = [], matriz = [] }) => {
	const { listCards, fortunas, tipos } = useContext(DefaultContext);
	const [fortuneStats, setFortuneStats] = useState({
		basicas: 0,
		naoBasicas: 0,
		detalhes: []
	});

	// Mapeamento dos ícones das fortunas
	const fortunaIcons = {
		'Ign': imgIgn,
		'Verbus': imgVerbus,
		'Karma': imgKarma,
		'Dnama': imgDnama,
		'Gnos': imgGnos,
		'Omna': imgOmna
	};

	useEffect(() => {
		if (!listCards || !fortunas) return;


		// Contar fortunas por tipo

		// Separar em básicas e não básicas usando a lista de tipos
		let basicasTotal = 0;
		let naoBasicasTotal = 0;
		const detalhes = [];

		Object.entries(matriz).forEach(([key, card]) => {
			// pegar todos os tipos do card
			const tiposDoCard = tipos.filter(t => card.card?.tipo?.includes(t.id));

			// checar se algum dos tipos é "Básica"
			const isBasica = tiposDoCard.some(t => t.tipo === "Básica");

			if (isBasica) {
				basicasTotal += card.qtd ?? 0;
			} else {
				naoBasicasTotal += card.qtd ?? 0;
			}

			detalhes.push({
				nome: card.nome,
				qtd: card.qtd,
				isBasica,
				tipos: tiposDoCard.map(t => t.tipo) // só pra debug
			});
		});


		setFortuneStats({
			basicas: basicasTotal,
			naoBasicas: naoBasicasTotal,
			detalhes: detalhes.sort((a, b) => b.qtd - a.qtd)
		});
	}, [arvore, matriz, listCards, fortunas]);

	const chartData = [
		{ name: 'Básica', value: fortuneStats.basicas, color: '#10B981' },
		{ name: 'Não Básica', value: fortuneStats.naoBasicas, color: '#8B5CF6' }
	].filter(item => item.value > 0);

	const CustomTooltip = ({ active, payload }) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;
			const total = fortuneStats.basicas + fortuneStats.naoBasicas;
			const percentage = total > 0 ? ((data.value / total) * 100).toFixed(1) : '0';
			return (
				<div className="bg-slate-800 border border-slate-600 rounded p-2 shadow-lg">
					<p className="text-slate-200">{`${data.name}: ${data.value} (${percentage}%)`}</p>
				</div>
			);
		}
		return null;
	};

	if (chartData.length === 0) {
		return (
			<div className="bg-slate-800 rounded-lg p-4 border border-slate-700">
				<h3 className="text-lg font-semibold text-slate-200 mb-4">🔮 Fortunas Básicas vs Não Básicas</h3>
				<div className="text-slate-500 text-center py-8">
					<div className="text-4xl mb-2">📊</div>
					<div>Nenhuma fortuna encontrada no deck</div>
				</div>
			</div>
		);
	}

	return (

		<div className="h-56 mb-4">
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={chartData}
						cx="50%"
						cy="50%"
						outerRadius={80}
						fill="#8884d8"
						dataKey="value"
						label={({ name, value }) => `${name}: ${value}`}
					>
						{chartData.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.color} />
						))}
					</Pie>
					<Tooltip content={<CustomTooltip />} />
				</PieChart>
			</ResponsiveContainer>
		</div>

	);
};

export default FortuneChart;